/* Built In Imports */
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';

/* External Imports */
import {
  Box, Flex, Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure
} from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import NewsLetterCard from '@components/UI/Newsletter/NewsLetterCard';
import NewsLetterPopup from '@components/UI/Newsletter/popup';
import CountriesList from '@constants/CountriesList';


/**
 * @param sectionContent
 */

const NewsLetterSubscription = ({ sectionContent, region }) => {
  const [activeCardCount, setActiveCardCount] = useState(0);
  const [selItems, setSelItems] = useState({});
  const [messagePop, setMessagePop] = useState('');
  const countries = CountriesList;
  const router = useRouter();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const finalRef = useRef(null);
  React.memo(countries);


  useEffect(() => {
    if (!isOpen && window?.loc?.indexOf('popup=1') > -1) {
      const parentUrl =
        location.origin +
        location.pathname +
        location.search.replace(/[\?&]popup=1/, '').replace(/^&/, '?');
      window.history.pushState(window.history.state, '', parentUrl);
    }
    // recaptchaRef?.current?.reset();
  }, [isOpen]);

  const updateCount = (count) => {
    setActiveCardCount(count);
  };

  const openPopup = (msg, isRefresh) => {
    onOpen();
    setMessagePop(msg);
    // let countList = activeCardCount;
    // if (isRefresh) {
    //   setActiveCardCount(0);
    //   setActiveCardCount(countList);
    // }
  };

  // split region from url and show appropriate country in dropdown by region
  let urlpath = router.asPath;
  let splitURL = urlpath.toString().split("/");

  const updateSelItems = (selected, lang, type, actionType) => {
    let items = selItems;
    if (selected) {
      if (actionType) {
        items[type] = lang;
      } else {
        delete items[type];
      }
    } else {
      items[type] = lang;
    }
    setSelItems(items);
  };

  return (
    <Box
      w="100%"
    >
      {activeCardCount > 0 && (
        <NewsLetterPopup
          count={activeCardCount}
          selItems={selItems}
          sectionContent={sectionContent}
          setMessagePop={openPopup}
        />
      )}
      <Flex
        flexWrap="wrap"
        maxW="1200px"
        margin="auto"
        p={{ base: "50px 0", md: "80px 0" }}
        alignItems={"flex-start"}
        justifyContent={{ base: "center", md: "flex-start" }}
      >
        {sectionContent.cards?.map((card, key) => {
          //console.log(card['title']);
          if ((splitURL[1] === 'us' || splitURL[1] === 'ca') && card['title'] != 'Shiva Newsletter') {
            return (
              <NewsLetterCard
                card={card}
                key={key}
                activeCardCount={activeCardCount}
                updateCount={updateCount}
                updateSelItems={updateSelItems}
                sectionContent={sectionContent}
                region={region}
                selItems={selItems}
              />
            );
          } else if (splitURL[1] != 'us' && splitURL[1] != 'ca') {
            return (
              <NewsLetterCard
                card={card}
                key={key}
                activeCardCount={activeCardCount}
                updateCount={updateCount}
                updateSelItems={updateSelItems}
                sectionContent={sectionContent}
                region={region}
                selItems={selItems}
              />
            );
          }
        })}
      </Flex>
      {messagePop && (
        <Box
          maxW={messagePop ? { base: '90%', md: '476px' } : 'auto'}
          m="20px auto"
        >
          <Modal
            finalFocusRef={finalRef}
            isOpen={isOpen}
            onClose={onClose}
            isCentered
            motionPreset="slideInBottom"
            size={'xl'}
            blockScrollOnMount={true}
            closeOnOverlayClick={false}
            p="0"
            w={{ base: "95%", md: "auto" }}
            height={{ base: "auto" }}
            borderRadius={{ base: '0', md: '0' }}
            top="50px"
          >
            <ModalOverlay />
            <ModalContent
              p={{ base: "15% 0 30px 15px", md: "30px" }}
              w={{ base: "95%", md: "auto" }}
              // height={{ base: "100vh", md: "auto" }}
              flexDirection="column"
            >
              <ModalCloseButton color="#9F9F9F" mt="1" />
              <ModalBody display="flex">{parser(messagePop || '')}</ModalBody>
            </ModalContent>
          </Modal>
        </Box>
      )}
    </Box>
  );
};

export default NewsLetterSubscription;